import $ from 'jquery';
import { initPriceWithVatState, setPriceWithoutVatCookies } from './price-vat-toggle';

$(() => {
  initPriceWithVatState();

  $(document).on('click', '#priceWithVat--desktop, #priceWithVat--mobile', (event) => {
    event.preventDefault();
    setPriceWithoutVatCookies()
      .then(() => {
        window.location.reload();
      });
  });
});
